module.exports = __webpack_public_path__ + "img/full5-min.23f33cb8.png";